import classNames from 'classnames'
import React from 'react'
import { toggleFullscreen } from '../../../store/map/map.actions'
import { selectIsMapFullScreen } from '../../../store/map/map.selectors'
import { withOnlyPE } from '../../Device'
import innerArrows from '../../genericComponents/assets/inner-arrows.svg'
import SVGIcon from '../../svg/SVGIcon'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import useEventCallback from '../../utils/useEventCallback'
import s from './ToggleFullscreenPeButton.less'

const ToggleFullscreenPeButton = () => {
  const execToggleFullscreen = useAction(toggleFullscreen)

  const onClick = useEventCallback(() => execToggleFullscreen(), [execToggleFullscreen])

  return (
    <div className={classNames('icon', s.ToggleFullscreenButton)} onClick={onClick}>
      <SVGIcon url={innerArrows} />
    </div>
  )
}

export default withOnlyPE(withEverySelectorTruthy(selectIsMapFullScreen)(ToggleFullscreenPeButton))
